






















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Description extends Vue {
  @Prop({ type: String, required: true }) private description!: string;
  @Prop({ type: String, required: false }) private avatarSrc!: string;
  @Prop({ type: Array, required: false }) private tags!: string[];
}
